export const OUTCOME = {
  won: { label: "Won", cls: "bg-emerald-500 text-slate-950" },
  placed: { label: "Placed", cls: "bg-blue-500 text-white" },
  unplaced: { label: "Unplaced", cls: "bg-slate-700 text-slate-300" },
};

export const outcomeOf = (number, result) => {
  if (!result) return null;
  const pos = result.placings.find((p) => p.number === number)?.position;
  return pos === 1 ? "won" : pos ? "placed" : "unplaced";
};

export const OutcomeBadge = ({ outcome, testid }) =>
  outcome ? <span data-testid={testid} className={`text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded ${OUTCOME[outcome].cls}`}>{OUTCOME[outcome].label}</span> : null;

const SRC = { puntersedge: "PuntersEdge", krok: "Krok Odds" };
const provisional = (r) => ["interim", "provisional", "unconfirmed"].includes(r.official_status);

export const RaceResult = ({ result, pending }) =>
  result ? (
    <div className="mt-3 flex flex-wrap items-center gap-2 text-xs" data-testid="race-result">
      <span className="uppercase tracking-widest text-emerald-400 font-bold">{provisional(result) ? "Provisional result" : "Result"}</span>
      {result.placings.map((p) => (
        <span key={`${p.position}-${p.number}`} className={`px-2 py-0.5 rounded-md border ${p.position === 1 ? "bg-emerald-500/15 border-emerald-500/40 text-emerald-200" : "bg-[#1B2640]/60 border-[#202E4C] text-slate-200"}`}>
          <span className="font-mono font-bold">{["1st", "2nd", "3rd"][p.position - 1] || `${p.position}th`}{result.placings.filter((q) => q.position === p.position).length > 1 ? " (DH)" : ""}</span> {p.number}. {p.horse}
        </span>
      ))}
      {result.source && <span className="text-slate-500" data-testid="race-result-source">via {SRC[result.source] || result.source}</span>}
    </div>
  ) : pending ? <p className="mt-3 text-xs text-slate-400" data-testid="race-result-pending">Results pending</p> : null;
